import { select, Selection } from "d3-selection";
import {PieChartOptions} from "../models/pie-chart-options.model";
import {PieChartEntry} from "../models/pie-chart-entry.model";

export class PieChartLegend {
    private _currentContext: JQuery<HTMLElement> = null;
    private _data: Array<PieChartEntry> = null;
    private _options: PieChartOptions = null;
    private _legendItems: Selection<HTMLLIElement, PieChartEntry, HTMLElement, unknown>;

    public constructor(
        currentContext: JQuery<HTMLElement>,
        data: Array<PieChartEntry>,
        options: PieChartOptions
    ) {
        this._currentContext = currentContext || this._currentContext;
        this._data = data || this._data;
        this._options = options || this._options;

        this.createLegend();
    }

    private createLegend(): void {
        const legendList = select(this._currentContext.get(0))
            .append("ul")
            .attr("class", "pcg-chart-legend");

        this._legendItems = legendList
            .selectAll("li")
            .data(this._data)
            .enter().append("li")
            .attr("class", "pcg-chart-legend__item");

        this._legendItems
            .append("span")
            .attr("class", "pcg-chart-legend__marker")
            .style("background-color", d => d.color);

        this._legendItems
            .append("span")
            .attr("class", "pcg-chart-legend__text")
            .text(d => d.label);

        if (this._options.handlers?.onClick) {
            this._legendItems
                .on("click", (event: MouseEvent, d: PieChartEntry) => {
                    const target = event.currentTarget as HTMLElement;
                    this._options.handlers.onClick(d, target);
                });
        }
    }

    public disable(el: HTMLElement, value: boolean): void {
        select(el).classed("pcg-chart-legend__item--disabled", value);
    }
}
